// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (max-width:768px){.el-message{min-width:200px!important}}@media (max-width:480px){.el-message{min-width:200px!important}}.version_pay_box{flex-wrap:unset!important}", ""]);
// Exports
module.exports = exports;
